class RelatedCombos extends HTMLElement {
  constructor() {
    super();
    //   this._onVariantChange();
    this.container = this;
    this.form = this.querySelector('[action="/cart/add"]');

    this.mainProduct = this.querySelector('[name="main_product_id"]');
    this.relatedProductRadios = [
      ...this.querySelectorAll('[name="related_product_id"]'),
    ];

    this.relatedProductVariants = this.relatedProductRadios
      .map((v) => {
        return v.getAttribute("data-variant")
          ? JSON.parse(v.getAttribute("data-variant"))
          : null;
      })
      .filter((v) => !!v);

    this.productCards = [...this.querySelectorAll(".related-product--card")];

    this.mainProductSelectedVariant = JSON.parse(
      this.mainProduct.getAttribute("data-variant")
    );
    this.relatedProductSelectedVariant = null;

    this.selectedVariants = [
      //   this.mainProductSelectedVariant,
      this.relatedProductSelectedVariant,
    ].filter((v) => !!v);

    setTimeout(() => {
      this.init();
    }, 500);

    // this.section = this.closest("section");
    // this.type = this.dataset.type;

    // this.productBuyForm = this.container.querySelector(
    //   'product-form-context [action="/cart/add"]'
    // );

    // this.addEventListener('change', this._onVariantChange);
    // this._internals = this.attachInternals();
  }

  connectedCallback() {
    // document.addEventListener(
    //   "ComboVariantSelector:updated",
    //   this._onVariantChange.bind(this)
    // );

    for (const relatedProductRadio of this.relatedProductRadios) {
      relatedProductRadio.addEventListener(
        "select",
        this._onProductRadioChange.bind(this)
      );
      relatedProductRadio.addEventListener(
        "change",
        this._onProductRadioChange.bind(this)
      );
    }
    for (const relatedProduct of this.productCards) {
      relatedProduct.addEventListener(
        "mouseenter",
        this._onProductMouseOver.bind(this)
      );
      relatedProduct.addEventListener(
        "mouseleave",
        this._onProductMouseOut.bind(this)
      );
    }
  }

  _onProductMouseOver(event) {
    event.preventDefault();
    let $this = this;
    let currentProduct = JSON.parse(
      event.target.querySelector("[data-variant]").getAttribute("data-variant")
    );
    let imgTarget = $this.querySelector("[data-featured-image] img");

    imgTarget.style.opacity = "0";

    setTimeout(() => {
      imgTarget.src = currentProduct.variant_featured_image;
      imgTarget.style.opacity = "1";
    }, 200);
  }
  _onProductMouseOut(event) {
    event.preventDefault();
    let $this = this;
    let currentProduct = JSON.parse(
      event.target.querySelector("[data-variant]").getAttribute("data-variant")
    );

    let originalImage = $this
      .querySelector("[data-featured-image]")
      .getAttribute("data-featured-image");
    let imgTarget = $this.querySelector("[data-featured-image] img");

    imgTarget.style.opacity = "0";

    setTimeout(() => {
      imgTarget.src = originalImage;
      imgTarget.style.opacity = "1";
    }, 200);
  }
  _onProductRadioChange(event) {
    event.preventDefault();
    let $this = this;
    let productsToAddInput = this.form.querySelector('[name="id"]');
    if (!productsToAddInput) return;

    this.relatedProductSelectedVariant = JSON.parse(
      event.target.getAttribute("data-variant")
    );

    this.selectedVariants = [
      //   this.mainProductSelectedVariant,
      this.relatedProductSelectedVariant,
    ].filter((v) => !!v);

    productsToAddInput.value = `${this.relatedProductSelectedVariant.variant_id}`;

    let bundleCompareAtPrice = this.selectedVariants.reduce((old, curr) => {
      return old + curr.variant_compare_at_price;
    }, 0);
    let bundlePrice = this.selectedVariants.reduce((old, curr) => {
      return old + curr.variant_price;
    }, 0);

    let renderUpdatedContent = (selector, htmlContent) => {
      $this.querySelector(selector).innerHTML = htmlContent;
    };

    renderUpdatedContent(
      ".related-combos--totals [bundle-compare-at-price]",
      window.SimpleCore._helpers.formatMoney(bundleCompareAtPrice)
    );
    renderUpdatedContent(
      ".related-combos--totals [bundle-price]",
      window.SimpleCore._helpers.formatMoney(bundlePrice)
    );
  }
  init() {
    let $this = this;
    let selectedRadio = this.relatedProductRadios.find((radio) => {
      return !!radio.checked;
    });
    selectedRadio.dispatchEvent(new Event("select", { bubbles: true }));
  }
  _onVariantChange(event) {
    // let $this = this;
    // let SelectedVariants = event.detail.data;
    // if (SelectedVariants) {
    //   let variantsCompareAtPrice = SelectedVariants.reduce((acc, cur) => {
    //     return acc + +cur.variant_compare_at_price;
    //   }, 0);
    //   let variantsPrice = SelectedVariants.reduce((acc, cur) => {
    //     return acc + +cur.variant_price;
    //   }, 0);
    //   let variantInstallmentInfo = calculateInstallment(variantsPrice);
    //   let renderUpdatedContent = (selector, htmlContent) => {
    //     this.querySelector(selector).innerHTML = htmlContent;
    //   };
    //   renderUpdatedContent(
    //     ".product--pricing .product--cut-price",
    //     window.SimpleCore._helpers.formatMoney(variantsCompareAtPrice)
    //   );
    //   renderUpdatedContent(
    //     ".product--pricing .product--actual-price",
    //     window.SimpleCore._helpers.formatMoney(variantsPrice)
    //   );
    //   renderUpdatedContent(
    //     ".product--pricing .price__parcel",
    //     `ou ${
    //       variantInstallmentInfo.installment_amount
    //     }x de ${window.SimpleCore._helpers.formatMoney(
    //       variantInstallmentInfo.installment_price
    //     )}`
    //   );
    //   renderUpdatedContent(
    //     ".ProductItem__Label.ProductItem__Label--onSale",
    //     `${(
    //       100 -
    //       (variantsPrice / variantsCompareAtPrice) * 100
    //     ).toFixed()}% off`
    //   );
    //   if ($this.productBuyForm) {
    //     let sourceInput = $this.productBuyForm.querySelector(
    //       'input[name="source"]'
    //     );
    //     if (!sourceInput) {
    //       sourceInput = document.createElement("input");
    //       sourceInput.type = "hidden";
    //       sourceInput.name = "properties[source]";
    //       $this.productBuyForm.appendChild(sourceInput);
    //     }
    //     sourceInput.value = "combo_variant_selector";
    //   }
    // }
  }
}
customElements.define("related-combos", RelatedCombos);
